namespace('compass.map');

compass.requireLib('compass.hotel.HotelFilter');

compass.map.BigMapWidget = compass.defineWidget(function(options) {

	var me = this;
	var $j = jQuery;

	var _settings = options;
	var _WUID = _settings.WUID;
	var _MAX_START_ZOOM = 14;
    //          <script src="https://maps.google.com/maps/api/js?sensor=true&client=gme-ttgonline&channel=arctic_twiggy"></script>

	this.selectedHotelId = null;
	// if this has a value it will be used to change the marker of the selected hotel.
	this.bounds = null;

	this.map = null;
	this.markers = [];
	this.markerIndex = {};

	var _hotels = _settings.hotels;

	//var _routeOrigin = _settings.routeOrigin;
	var _routeOriginHotel = _settings.routeOriginHotel;

    var _filteredImage = null;
    var _filteredShadow = null;
	
	var _render = this.render = function(widgetElem) {
		var d = _d;
		me.setData(_hotels);
		widgetElem.append(d.div({ className : 'bigMapWidgetMap' }));
		if(widgetElem.is(':visible')) {
			me.draw();
		}
	};

	this.setData = function(hotels) {
		_hotels = hotels;
		this.selectedHotelId = null;
		_filter.setData(_hotels);
	};

	this.resizeMap = function(newHeight) {
		//me.find('.bigMapWidgetMap').css({ height : newHeight });
		if(me.map) {
			google.maps.event.trigger(me.map, 'resize');
		}
	};

	var _currMarker = { };

	var _redraw = function(hotels){
		_hotels = hotels;
		if( me.getWidgetElem().is(':visible') ) {
			me.draw();
		}
	};

	this.draw = function(optionsArg) {
		if ( window.google == null || window.google.maps == null ){
			compass.loading.start();
            window.__compass_google_callback = function(){
            	me.getWidgetElem().show(); // warning: has to come before the updateFilter call
            	me.updateFilter(); // will call redraw which will call draw which will set up the map, only then will be we be able to call _show(), _hide()
            	$j('.mapTab').removeClass('disabled').addClass("mapLoaded");
            };
            
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.google.com/maps/api/js?sensor=true&client=gme-ttgonline&channel=arctic' + '&callback=__compass_google_callback';
            document.body.appendChild(script);
            return;
        }
        compass.loading.stop();
        me.getWidgetElem().show();
        _filteredImage = new google.maps.MarkerImage(
            compass.staticPrefix + '/resources/img/compass/map/marker_filtered_icon.png'
        );
        _filteredShadow = new google.maps.MarkerImage(
            compass.staticPrefix + '/resources/img/compass/map/marker_selected_shadow.png',
            new google.maps.Size(26, 34),
            new google.maps.Point(0, 0),
            new google.maps.Point(2, 34)
        );



		var latlng = new google.maps.LatLng(_settings.meetingInfo.site.latitude, _settings.meetingInfo.site.longitude);
		var myOptions = {
			zoom : 14,
			maxZoom : _MAX_START_ZOOM,
			center : latlng,
			mapTypeId : google.maps.MapTypeId.ROADMAP,
			styles : _settings.mapStyles
		};

		me.map = new google.maps.Map(me.find('.bigMapWidgetMap').get(0), myOptions);
		var siteLatlng = new google.maps.LatLng(_settings.meetingInfo.site.latitude, _settings.meetingInfo.site.longitude);

		var siteMarker = new google.maps.Marker({
			position : siteLatlng,
			title : _settings.meetingInfo.site.name,
			zIndex : -1
		});
		siteMarker.setMap(me.map);
		if(_settings.useSiteMarker) {
			var siteMarkerImage = new google.maps.MarkerImage(
					compass.staticPrefix + '/resources/img/compass/map/conference.png'
			);
			var siteMarkerShadow = new google.maps.MarkerImage(
				compass.staticPrefix + '/resources/img/compass/map/conference_shadow.png',
				new google.maps.Size(46, 18),
				new google.maps.Point(0, 0),
				new google.maps.Point(18, 18)
			);
			siteMarker.setIcon(siteMarkerImage);
			siteMarker.setShadow(siteMarkerShadow);
			google.maps.event.addListener(siteMarker, 'click', function() {
				if(_currMarker.info) { _currMarker.info.close(); }
				_currMarker = {
					info : new google.maps.InfoWindow({ content : _d.div({ className : 'siteNameWrapper' },
						_d.p({ className : 'siteName' }, _settings.meetingInfo.site.name )
					).get(0) }),
					marker : siteMarker
				};
				_currMarker.info.open(me.map, siteMarker);
			});
		}

		if (_settings.meetingInfo.alternateSites.length > 0) {
			_.each(_settings.meetingInfo.alternateSites, function(site) {
				var altSiteLatLng = new google.maps.LatLng(site.latitude, site.longitude);
				var altSiteMarker = new google.maps.Marker({
					position: altSiteLatLng,
					title: site.name,
					zIndex: -1
				});

				altSiteMarker.setMap(me.map);

				if(_settings.useSiteMarker) {
					var altSiteMarkerImage = new google.maps.MarkerImage(
							compass.staticPrefix + '/resources/img/compass/map/conference.png'
					);
					var altSiteMarkerShadow = new google.maps.MarkerImage(
						compass.staticPrefix + '/resources/img/compass/map/conference_shadow.png',
						new google.maps.Size(46, 18),
						new google.maps.Point(0, 0),
						new google.maps.Point(18, 18)
					);
					altSiteMarker.setIcon(altSiteMarkerImage);
					altSiteMarker.setShadow(altSiteMarkerShadow);
					google.maps.event.addListener(altSiteMarker, 'click', function() {
						if(_currMarker.info) { _currMarker.info.close(); }
						_currMarker = {
							info : new google.maps.InfoWindow({ content : _d.div({ className : 'siteNameWrapper' },
								_d.p({ className : 'siteName' }, site.name )
							).get(0) }),
							marker : altSiteMarker
						};
						_currMarker.info.open(me.map, altSiteMarker);
					});
				}
			});
		}

		if(_hotels.length === 0) {
			me.map.setCenter(siteLatlng);
		} else {
			var bounds = new google.maps.LatLngBounds();
			bounds.extend(siteLatlng);
			for(var i = 0; i < _hotels.length; i++) {
				var hotel = _hotels[i];
				var soldOut = !(hotel.avail.status == 'NORMAL' || hotel.avail.status == 'GDS');
				var myLatlng = new google.maps.LatLng(hotel.latitude, hotel.longitude);
				var marker = new google.maps.Marker({
					position : myLatlng,
					title : hotel.name.replace(/&amp;/g, '&')
				});

				if(soldOut) {
					marker.defaultIcon = _filteredImage;
					marker.setIcon(_filteredImage);
					marker.setShadow(_filteredShadow);
				}

				marker.setMap(me.map);
				marker.filtered = false;
				(function(marker, hotel) {
					google.maps.event.addListener(marker, 'click', function() {
						if(!marker.filtered && !hotel.disabled) {
							if(_currMarker.info) { _currMarker.info.close(); }
							var wrapper = _d.div();
							var card = new compass.hotel.HotelCardWidget(wrapper, {
								meetingInfo : _settings.meetingInfo,
								WUID : 'BigMapWidget_HotelCardWidget_' + _WUID,
								hotel : hotel,
								displayHotelStars: _settings.displayHotelStars,
								hideDistance: _settings.hideDistance,
								hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable
							});
							_currMarker = {
								info : new google.maps.InfoWindow({ content : wrapper.get(0)}),
								marker : marker
							};
							_currMarker.info.open(me.map, marker);
						}
					});
				})(marker, hotel);
				me.markers[hotel.hotelId] = {
					hotel : hotel,
					marker : marker
				};

				bounds.extend(marker.getPosition());
			}
			me.map.fitBounds(bounds);
			google.maps.event.addListenerOnce(me.map, 'zoom_changed', function () {
				if (me.map.getZoom() > _MAX_START_ZOOM) {
					me.map.setZoom(_MAX_START_ZOOM);
				}
			});
			//me.updateFilter(_currFilter);
		}

		if(_routeOriginHotel) {
			var originMarker = me.markers[_routeOriginHotel];
			if(originMarker) {
				var dirService = new google.maps.DirectionsService();
				var dirDisplay = new google.maps.DirectionsRenderer({
					map : me.map,
					suppressMarkers : true,
					preserveViewport : true
				});

				google.maps.event.addListener(originMarker.marker, 'click', function() {
					if(_currMarker.info) { _currMarker.info.close(); }
					_currMarker = {
						info : new google.maps.InfoWindow({
							content : _d.div({ className : 'siteNameWrapper' },
								_d.p({ className : 'siteName' }, originMarker.hotel.name)
							).get(0),
							maxWidth: 200
						}),
						marker : originMarker.marker
					};
					_currMarker.info.open(me.map, originMarker.marker);
				});
			}
		}

		me.map.setOptions({ maxZoom: null });
	};

	var _hide = function(hotelId) {
		return function() {
			if(me.getWidgetElem().is(':visible')) {
				var marker = me.markers[hotelId].marker;
				if(!marker.filtered) {
					if(marker === _currMarker.marker) {
						_currMarker.info.close();
					}
					marker.defaultIcon = marker.getIcon();
					marker.filtered = true;
					marker.setIcon(_filteredImage);
					marker.setShadow(_filteredShadow);
				}
			}
		};
	};

	var _show = function(hotelId) {
		return function() {
			if(me.getWidgetElem().is(':visible')) {
				var marker = me.markers[hotelId].marker;
				marker.filtered = false;
				marker.setIcon(marker.defaultIcon);
			}
		};
	};

	// passing in undefined for the
	var _filter = new compass.hotel.HotelFilter(_hide, _show, undefined, _redraw);

	var _currFilter = { };
	this.updateFilter = function(filterObj) {
		_currFilter = (filterObj || _currFilter);
		_filter.updateFilter(_currFilter);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	'WUID' : 'crap',
	widgetName : 'BigMapWidget',
	imgPath : '/resources/img',
	useSiteMarker : true,
	displayHotelStars: true,
	site : {
		name : 'SET_THIS',
		longitude : -87.623500000,
		latitude : 41.895700000
	},
	hotels : [ ],
	mapStyles : [{
		featureType : 'road',
		elementType : 'labels',
		stylers : [
			{ saturation : -100 },
			{ lightness : 50 }
		]
	}, {
		featureType : 'road.highway',
		elementType : 'labels',
		stylers : [
			{ saturation : 30 },
			{ hue : '#004CFF' }
		]
	}, {
		featureType : 'road.highway',
		elementType : 'geometry',
		stylers : [
			{ saturation : -100 },
			{ lightness : 40 }
		]
	}, {
		featureType : 'road.arterial',
		elementType : 'geometry',
		stylers : [
			{ saturation : -100 },
			{ lightness : 70 },
			{ gamma : 0.4 },
			{ visibility : 'simlified' }
		]
	}, {
		featureType : 'road.local',
		elementType : 'geometry',
		stylers : [
			{ saturation : -100 },
			{ lightness : 20 },
			{ gamma : 0.8 },
			{ visibility : 'simlified' }
		]
	}, {
		featureType : 'administrative',
		elementType : 'labels',
		stylers : [{ lightness : -2 }]
	}, {
		featureType : 'landscape.man_made',
		elementType : 'geometry',
		stylers : [{ hue : '#DEDDD8' }]
	}, {
		featureType : 'landscape',
		elementType : 'labels',
		stylers : [{ lightness : -2 }]
	}, {
		featureType : 'poi',
		elementType : 'labels',
		stylers : [
			{ saturation : -100 },
			{ lightness : 20 }
		]
	}, {
		featureType : 'water',
		elementType : 'labels',
		stylers : [{ lightness : -2 }]
	}, {
		featureType : 'transit',
		elementType : 'all',
		stylers : [{ visibility : 'off' }]
	}],
	hotelReponse : [{
		hotel_id : 1
	}]
});

